exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.physical_card_tabs[data-v-166399b7] {\n  padding: 12px;\n}\n", ""]);

// exports
